<div>
  @if (form(); as authForm) {
    <glxy-form-field>
      <glxy-label>{{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.LABEL' | translate }}</glxy-label>
      <mat-select (selectionChange)="typeChange($event.value)" [formControl]="authForm.controls.type">
        <mat-option value="unspecified">
          {{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.NONE' | translate }}
        </mat-option>
        <mat-option value="platformManaged">
          {{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.VENDASTA_AUTH' | translate }}
        </mat-option>
        <mat-option value="impersonation">
          {{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.IMPERSONATION' | translate }}
        </mat-option>
        <mat-option value="connectedIntegration">
          {{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.CONNECTED_INTEGRATION' | translate }}
        </mat-option>
      </mat-select>
    </glxy-form-field>

    @if (authForm.controls.type.value === 'platformManaged' || authForm.controls.type.value === 'impersonation') {
      @if (showScopes()) {
        @if (scopeOptions$ | async; as scopeOptions) {
          <glxy-form-field>
            <glxy-label>{{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.REQUIRED_SCOPES' | translate }}</glxy-label>
            <mat-select [formControl]="authForm.controls.requiredScopes" multiple>
              @for (scopeOption of scopeOptions; track scopeOption) {
                <mat-option [value]="scopeOption">
                  {{ scopeOption }}
                </mat-option>
              }
            </mat-select>
          </glxy-form-field>
        } @else {
          <div>{{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.LOADING_SCOPES' | translate }}</div>
        }
      }
    }

    @if (authForm.controls.type.value === 'connectedIntegration') {
      <glxy-form-field>
        <glxy-label>
          {{ 'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.CONNECTION_ID.LABEL' | translate }}
          <mat-icon
            class="info-icon"
            [glxyTooltip]="'AI_ASSISTANT.FUNCTIONS.AUTH_STRATEGY.CONNECTION_ID.HINT' | translate"
          >
            info_outline
          </mat-icon>
        </glxy-label>
        <input type="text" [formControl]="authForm.controls.connectedIntegrationId" />
      </glxy-form-field>
    }
  }
</div>
